import { Suspense, lazy } from 'react'
import { BrowserRouter, Link, Route, Routes } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import { Button } from '@/components/ui/button'
import { Home } from '@/pages/Home'

/*
  A home é a porta de entrada e não usa o Firebase SDK. Carregar as rotas que
  usam — a página da placa e Minhas consultas — só quando alguém chega nelas
  mantém a primeira dobra leve, já que o SDK responde pela maior parte do bundle.
*/
const Consulta = lazy(() =>
  import('@/pages/Consulta').then((module) => ({ default: module.Consulta })),
)
const MinhasConsultas = lazy(() =>
  import('@/pages/MinhasConsultas').then((module) => ({ default: module.MinhasConsultas })),
)
const Termos = lazy(() =>
  import('@/pages/Termos').then((module) => ({ default: module.Termos })),
)
const Privacidade = lazy(() =>
  import('@/pages/Privacidade').then((module) => ({ default: module.Privacidade })),
)

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route
            path="/consulta"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Consulta />
              </Suspense>
            }
          />
          <Route
            path="/consulta/:placa"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Consulta />
              </Suspense>
            }
          />
          <Route
            path="/minhas-consultas"
            element={
              <Suspense fallback={<RouteFallback />}>
                <MinhasConsultas />
              </Suspense>
            }
          />
          {/* "Já paguei" leva à mesma entrada por e-mail. */}
          <Route
            path="/ja-paguei"
            element={
              <Suspense fallback={<RouteFallback />}>
                <MinhasConsultas />
              </Suspense>
            }
          />
          <Route
            path="/termos"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Termos />
              </Suspense>
            }
          />
          <Route
            path="/privacidade"
            element={
              <Suspense fallback={<RouteFallback />}>
                <Privacidade />
              </Suspense>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

function RouteFallback() {
  return (
    <div className="container-page flex flex-col gap-6 py-8">
      <div className="h-32 animate-pulse rounded-xl bg-secondary" />
      <div className="h-64 animate-pulse rounded-xl bg-secondary" />
    </div>
  )
}

function NotFound() {
  return (
    <div className="container-page py-20 text-center">
      <h1 className="text-2xl font-bold">Página não encontrada</h1>
      <p className="mt-2 text-muted-foreground">
        O endereço que você abriu não existe no Origem Veicular.
      </p>
      <Button asChild className="mt-6">
        <Link to="/">Consultar uma placa</Link>
      </Button>
    </div>
  )
}
